<template>
  <div>
    <h2 class="mb-4">
      Review and Confirm
    </h2>

    <section class="c-college-storage-section border p-4 mb-4">
      <h3 class="c-college-storage-section__title">
        Your Information
      </h3>

      <div class="row">
        <div
          v-for="(i, index) in userInfo"
          :key="index"
          class="col-6 c-user-info-field mb-4"
        >
          <div
            class="c-user-info-field__title mb-2"
          >
            {{ i.label }}
          </div>
          <span
            class="c-user-info-field__value"
            v-html="i.value"
          />
        </div>
      </div>
    </section>

    <!--
    <control-checkbox
      v-model="formData.shipping_to_bc"
      class="mb-3"
      label="Shipping To Bue Crates (handling fee $100)"
      @input="forceRefreshCheckout"
    />
    -->

    <section class="c-college-storage-section border p-4 mb-4">
      <h3 class="c-college-storage-section__title">
        Order Summary
      </h3>

      <div v-if="$store.state.collegeStorage.orderItemsState === null">
        <table class="table c-college-storage__order-summary text-left">
          <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Price per Unit</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(i, index) in orderItems"
            :key="index"
          >
            <td>
              <div class="d-flex justify-content-center align-items-center">
                <div class="flex-shrink-0">
                  <img
                    v-if="i.icon"
                    alt="icon"
                    :src="i.icon"
                    style="width: 32px; height: 32px;"
                  >
                </div>
                <div class="flex-grow-1">
                  {{ i.title }}

                  <div v-if="i.description" class="mt-1">
                    <span class="text-muted">
                      {{ i.description }}
                    </span>
                  </div>
                </div>
              </div>
            </td>
            <td>
              {{ i.quantity }}
            </td>
            <td>
              {{ formatMoney(i.price) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-else-if="$store.state.collegeStorage.orderItemsState === 'loading'">
        Loading...
      </div>

      <div
        v-if="$store.state.collegeStorage.orderItemsError"
        class="mb-3"
      >
        <p class="text-danger mb-3">
          {{ $store.state.collegeStorage.orderItemsError }}
        </p>

        <div>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="forceRefreshCheckout"
          >
            Refresh Checkout
          </button>
        </div>
      </div>
    </section>

    <section class="c-college-storage-section border p-4 mb-4">
      <h3 class="c-college-storage-section__title">
        Payment Info
      </h3>

      <div class="c-payment-strategy mb-3">
        <div
          v-for="(i, index) in paymentStrategies"
          :key="index"
        >
          <div class="custom-control custom-radio mb-3">
            <input
              v-model="formData.payment_strategy"
              :id="'paymentStrategy_' + i.value"
              class="custom-control-input"
              type="radio"
              name="insurance"
              :value="i.value"
              @change="forceRefreshCheckout()"
            >

            <label
                class="custom-control-label"
                :for="'paymentStrategy_' + i.value"
            >
              <span v-html="i.text"/>
            </label>

            <div
              v-if="i.description"
              class="mt-3 text-uppercase"
              v-html="i.description"
            />
          </div>
        </div>
      </div>

      <div class="mt-4">
        <PaymentMethodWidget
          ref="paymentForm"
          :user-cards="$store.state.collegeStorage.userCards"
        />
      </div>

      <div class="form-group">
        <label class="form-label">
          {{ formData.promo_code.getLabel() }}
        </label>

        <div>
          <input
            v-model="formData.promo_code.value"
            class="form-control w-auto"
            :disabled="isBusy"
            @input="handlePromoCodeInputChanged"
          />

          <div class="mt-3">
            <div
              v-if="isBusy"
              class="text-info"
            >
              Loading...
            </div>
            <div v-else>
              <div
                v-if="$store.state.collegeStorage.promoCode.has_promo_code"
                class="mt-3"
              >
                <div
                  v-if="$store.state.collegeStorage.promoCode.is_ok"
                  class="text-success"
                >
                  <span class="fa fa-check-circle"></span>
                  {{ $store.state.collegeStorage.promoCode.message }}
                </div>
                <div
                  v-else
                  class="text-danger"
                >
                  <span class="fa fa-exclamation-triangle"></span>
                  {{ $store.state.collegeStorage.promoCode.message }}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="c-college-storage-section border p-4 mb-4">
      <h5>
        <span class="fa fa-info-circle text-muted"></span>
        Label Distribution
      </h5>

      <p>
        We will ship your labels and supplies directly to the address on your account.
      </p>

      <h5>
        <span class="fa fa-info-circle text-muted"></span>
        Pickup
      </h5>

      <p>
        Pickups will be conducted from your address on your account.
      </p>

      <h5>
        <span class="fa fa-info-circle text-muted"></span>
        Delivery
      </h5>

      <p>
        Deliveries will be made to on-campus housing prior to the beginning of the next  term unless you opt to extend your storage.
      </p>
    </section>

    <!--
    <section class="c-college-storage-section border p-4 mb-4">
      <h5>
        <span class="fa fa-info-circle text-muted"></span>
        Item Verification and Label Distribution Date
      </h5>

      <p>
        We will be on campus prior to pickup to distribute your labels, register your items, and distribute supplies.
      </p>

      <h5>
        <span class="fa fa-info-circle text-muted"></span>
        Spring Pickup
      </h5>

      <p>
        All pickups will be done after students have left campus. No need to schedule a pickup.
      </p>

      <h5>
        <span class="fa fa-info-circle text-muted"></span>
        Fall Delivery
      </h5>

      <p>
        Fall deliveries to be conducted prior to student arrival in coordination with the university. No need to
        schedule.
      </p>
    </section>
    -->

    <section class="c-college-storage-section border p-4 mb-4">
      <h3 class="c-college-storage-section__title">
        Checkout
      </h3>

      <table class="table c-college-storage__checkout">
        <tbody>
        <tr>
          <td class="font-weight-bold">
            Subtotal
          </td>
          <td>
            {{ formatMoney(checkout.subtotal) }}
          </td>
        </tr>
        <tr v-if="checkout.delivery > 0">
          <td class="font-weight-bold">
            Delivery
          </td>
          <td>
            {{ formatMoney(checkout.delivery) }}
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold">
            Extras

            <AppInfo
              text="Additional add ons like supplies and extra items on top of the 7 items included in your Student Storage."
            />
          </td>
          <td>
            {{ formatMoney(checkout.extras) }}
          </td>
        </tr>
        <tr v-if="checkout.has_discount">
          <td class="font-weight-bold">
            Discount
          </td>
          <td>
            {{ formatMoney(checkout.discount_amount) }}
          </td>
        </tr>
        <tr class="font-weight-bold">
          <td>
            Total
          </td>
          <td>
            {{ formatMoney(checkout.total) }}
          </td>
        </tr>
        <tr class="font-weight-bold">
          <td>
            Total Today
          </td>
          <td>
            {{ formatMoney(checkout.total_today) }}
          </td>
        </tr>
        </tbody>
      </table>
    </section>

    <control-checkbox
      v-model="formData.send_me_deals"
      class="mb-3"
      label="Send me deals and organization tips"
    />

    <div class="mb-3">
      By clicking "Confirm Purchase", you agree to our
      <a
        :href="config.termsAndConditionsPageUrl"
        target="_blank"
      >Terms and Conditions
      </a>
    </div>

    <div
      v-show="validationErrors.length"
      class="border border-danger rounded-3 bg-danger text-white p-4"
    >
      <div
        v-for="(error, index) in validationErrors"
        :key="index"
      >
        {{ error }}
      </div>
    </div>

    <CollegeStorageNavigation
      :next-label="nextLabel"
      :next-button-options="nextButtonOptions"
      @back-button-clicked="handleGoBack"
      @next-button-clicked="submit"
    />

    <div class="text-center">
      Confirm your purchase to select insurance options
    </div>
  </div>
</template>

<script lang="ts">
import ControlCheckbox from "@app-components/controls/control-checkbox.vue";
import ControlSelect from "@app-components/controls/control-select.vue";
import AppInfo from "@app-components/app-info.vue";
import {format} from "date-fns";
import {defaultPresenter} from "@app/components/presenters.js";
import CollegeStorageNavigation from "./Navigation.vue";
import Vue from "vue";
import Component from "vue-class-component";
import {CheckoutFormData, CheckoutInfo, PaymentStrategy} from "@/UI/stores/college-storage";
import * as _ from "lodash";
import config from "@/config";
import PaymentMethodWidget from "@/UI/widgets/PaymentMethodWidget.vue";

const DATE_FORMAT = "EEEE, LL/dd/yy 'at' hh:mm aaa";

@Component({
  components: {
    PaymentMethodWidget,
    CollegeStorageNavigation,
    AppInfo,
    ControlSelect,
    ControlCheckbox
  },
})
export default class CollegeStorage_Summary extends Vue {
  paymentStrategies = [
    {
      text: '<strong>One Time</strong> - Includes everything in package plus add ons.',
      description: null,
      value: PaymentStrategy.ONE_TIME,
    },
    {
      text: `<strong>Three Equal Payments</strong> - Includes everything in package plus add ons paid in three equal payments`,
      description: "Time of purchase ➔ Jan 15th ➔ Feb 15th",
      value: PaymentStrategy.INSTALLMENT,
    },
  ];

  formData: CheckoutFormData = this.$store.state.collegeStorage.checkoutFormData;
  checkout: CheckoutInfo = this.$store.state.collegeStorage.checkoutInvoiceInfo;

  validationErrors: string[] = [];

  refreshDebouncer = _.debounce(() => {
    this.forceRefreshCheckout();
  }, 700);

  isBusy = false;

  $refs!: {
    paymentForm: any
  };

  get config() {
    return config;
  }

  get nextLabel() {
    if (this.isBusy)
      return `Order processing...`;

    return "Confirm Purchase & Select Insurance";
  }

  get nextButtonOptions() {
    return {
      disabled: this.isBusy
    };
  }

  get orderItems() {
    return this.$store.state.collegeStorage.orderItems;
  }

  get userInfo() {
    let items = this.$store.getters["collegeStorage/userDataFields"];

    return items.filter((i) => i.value !== null);
  }

  handlePromoCodeInputChanged() {
    this.refreshDebouncer();
  }

  forceRefreshCheckout() {
    this.$store.dispatch("collegeStorage/refreshCheckout");

    this.refreshPaymentData();
  }

  refreshPaymentData() {
    let self = this;

    return new Promise((resolve, reject) => {
      this.$refs.paymentForm.requestPaymentMethod()
        .then((paymentFormData) => {
          console.debug("Payment method has been refreshed", paymentFormData);

          self.formData.payment = paymentFormData;

          resolve(paymentFormData);
        })
        .catch((error) => {
          console.error(error);

          reject(error);
        });
    });
  }

  formatMoney(value) {
    return '$' + value.toFixed(2);
  }

  formatDate(value) {
    return defaultPresenter.getMapped(value, (value) => {
      if (typeof (value) == 'string')
        value = new Date(value);

      return format(value, DATE_FORMAT);
    });
  }

  handleGoBack() {
    this.$emit('back-button-clicked');
  }

  clearErrors() {
    this.validationErrors = [];
  }

  resetBusyState() {
    setTimeout(() => {
      this.isBusy = false;
    }, 1000);
  }

  submit() {
    let self = this;

    self.clearErrors();

    self.isBusy = true;

    this.refreshPaymentData()
      .then(() => {
        this.$store.dispatch("collegeStorage/submitOrder")
          .then((data) => {
            console.info("Order created. Redirecting...");

            if (data.hasOwnProperty('redirect_to')) {
              window.location.href = data.redirect_to;
            }
          })
          .catch((error) => {
            if (error.status === 422) {
              self.validationErrors.push("Got a validation error. Please go to the previous steps and check if the fields are filled correctly.");

              let messages = _.flatten(Object.values(error.data.errors)) as string[];

              self.validationErrors.push(...messages);
            } else {
              if (error.data.hasOwnProperty('message'))
                self.validationErrors.push(error.data.message);
              else
                self.validationErrors.push("Got an internal error. We are working on fixing it. Please try again later.");
            }
          })
          .finally(() => {
            self.resetBusyState();
          });
      })
      .catch((error) => {
        self.validationErrors.push("Please fill out your payment info");

        this.resetBusyState();
      });
  }
}
</script>

<style scoped lang="scss">
h5 {
  font-size: 1rem;
}

.c-emphasized-date {
  font-weight: bold;
}

.c-user-info-field__title {
  font-weight: bold;
}

.c-college-storage-section__title {
  font-size: 22px;
  margin-bottom: 1.75rem;
}

.c-college-storage__order-summary {
  td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

.c-college-storage__checkout {
  td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
</style>
